import { areaQueryKeys as e } from "./useAreaQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { areaApi as n } from "@maat/api-main";
//#region src/areas/useFeaturedAreasQuery.ts
var r = () => t({
	queryKey: e.featured(),
	queryFn: () => n.getFeaturedAreas(),
	staleTime: 600 * 1e3
});
//#endregion
export { r as useFeaturedAreasQuery };
